import axios from 'axios';
const base = process.env.NODE_ENV === 'development' ? '/api' : '';
//SaaS Web端 注册供货商和账号接口
export const registerUserHotel = (params) => { return axios.post(`${base}/base/v1/register/registerUserHotel`, params) };

// 登陆
export const userLogin = params => { return axios.post(`${base}/base/bms/permission/userlogin/login`, `${params}`) };


// WEBPACK FOOTER //
// ./src/api/api.js